import SectionHeader from 'components/SectionHeader';
import Table from 'components/Table/TableStatic';
import Truncator from 'components/Truncator';
import {SendDocument} from 'pages/History/SendingOrders/Details/types';
import {FC} from 'react';
import {t} from 'ttag';

type SendViaPeppolSendStatusProps = {
    isSelected: boolean;
    sentDocumentSet?: SendDocument[];
    statusDescription: string;
};

const SendViaPeppolSendStatus: FC<SendViaPeppolSendStatusProps> = ({
    isSelected,
    sentDocumentSet,
    statusDescription,
}) => {
    if (!isSelected) {
        return null;
    }

    return (
        <div className="flex flex-col gap-4">
            <SectionHeader title={t`"Peppol Send" Status`} />
            <span className="text-base">{statusDescription}</span>
            {sentDocumentSet && (
                <Table classNameTable="table-fixed">
                    <Table.Header>
                        <Table.HeaderRow>
                            <Table.Column className="w-1/2">{t`Document`}</Table.Column>
                            <Table.Column className="flex w-1/2 items-center gap-2">
                                {t`Status`}
                            </Table.Column>
                        </Table.HeaderRow>
                    </Table.Header>
                    <Table.Body>
                        {sentDocumentSet.map((data) => (
                            <Table.Row key={data.mid}>
                                <Table.Cell>
                                    <Truncator text={data.document} />
                                </Table.Cell>
                                <Table.Cell>
                                    <Truncator text={data.displayStatus} />
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            )}
        </div>
    );
};
export default SendViaPeppolSendStatus;
